export const contingentDeleteOutlineIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12"><path d="M.5 2.5h11M4.5 2.5v-2h3v2M9.5 4.5v6a1 1 0 01-1 1h-5a1 1 0 01-1-1v-6" stroke="#9D3D4E" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'delete-outline',
};
